import React, { useEffect } from 'react'
import Navbar from '../../GlobalComponents/Navbar/Navbar'
import MobileNavbar from '../../../Mobile/MobGlobalComponents/MobileNavbar/MobileNavbar'
import { useNavigate, useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { fetchCartDetails } from '../../../../utils/cartSlice'

export const PaymentSuccessPage = ({ user }) => {
	const navigate = useNavigate()
	const dispatch = useDispatch()
	const location = useLocation() // Hook to get the current location

	useEffect(() => {
		// Scroll to the top whenever the location changes
		window.scrollTo(0, 0)
	}, [location]) // Dependency on location
	useEffect(() => {
		// localStorage.setItem('paymentCompleted', 'true')
		// window.location.replace('/')
		const timer = setTimeout(() => {
			navigate('/')
		}, 3000) // 3000ms = 3 seconds

		return () => clearTimeout(timer) // Clean up the timer on component unmount
	}, [navigate])

	useEffect(() => {
		dispatch(fetchCartDetails())
		// Initialize the cart from localStorage when the app loads
	}, [])

	return (
		<>
			<div className='display'>
				<Navbar user={user} />
				<PaymentSuccessPageMain />
			</div>
			<div className='display-full'>
				<MobileNavbar user={user} />
				<PaymentSuccessPageMain />
			</div>
		</>
	)
}

const PaymentSuccessPageMain = () => {
	return (
		<div className='min-h-screen flex items-center justify-center mt-10'>
			<div className='text-center'>
				<svg className='mx-auto mb-4' width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'>
					<circle cx='50' cy='50' r='45' fill='#4CAF50' />
					<path
						d='M70 35c0-1.7-1.3-3-3-3s-3 1.3-3 3v10c0 1.7 1.3 3 3 3s3-1.3 3-3V35zM36 35c0-1.7-1.3-3-3-3s-3 1.3-3 3v10c0 1.7 1.3 3 3 3s3-1.3 3-3V35z'
						fill='#FFFFFF'
					/>
					<path d='M68.5 65c-12.7 10.9-24.3 10.9-37 0' fill='none' stroke='#FFFFFF' strokeWidth='5' strokeLinecap='round' />
				</svg>

				<h1 className='text-3xl font-bold text-gray-800 mb-2'>Order Placed Successfully!</h1>
				<p className='text-gray-600'>Thank you for your purchase. Your order is being processed.</p>
			</div>
		</div>
	)
}
